<template>
    <Toast />
    <div>
        <div class="p-d-flex p-jc-between">
            <p class="profile-title">Vendor Selection</p>
            <div v-if="show">
                <Button label="Cancel" class="p-button-outlined button" @click="cancel" />
                <Button label="Save" class="button" @click="saveChanges" />
                <FloatingSaveCancel @save="saveChanges" @cancel="cancel" />
            </div>
        </div>

        <Accordion :activeIndex="0">
            <AccordionTab header="Add or Remove Vendors from your Channel">
                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-12 p-px-5">
                        <div class="field-title">Vendor List</div>

                        <table class="channels-table">
                            <thead>
                                <tr>
                                    <th>Enable</th>
                                    <th>Partner Name</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="partner in partners" :key="partner.id">
                                    <td class="switch-column">
                                        <InputSwitch 
                                            v-model="partner.isPartOfThisChannel" 
                                            @change="togglePartner(partner)"
                                        />
                                    </td>
                                    <td class="partner-name-column">
                                        {{ partner.name }}
                                    </td>
                                    <td>
                                        {{ partner.isPartOfThisChannel ? 'Active' : 'Inactive' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script>
import { onMounted } from '@vue/runtime-core';
import FloatingSaveCancel from '../components/common/FloatingSaveCancel.vue';
import AccountMangementService from '../service/AccountManagementService';
import CurrentUserService from '../service/CurrentUserService';
import { getAccount, getAccountId, getIsChannel } from '../service/common';

export default {
    components: {
        FloatingSaveCancel,
    },
    data() {
        return {
            partners: [],
            show: false,
            originalPartnerStates: {}
        };
    },
    created() {
        this.isChannel = getIsChannel();
        this.isAdmin = getAccount();

        console.log({
            isChannel: this.isChannel,
            isAdmin: this.isAdmin
        })
        this.accountMangementService = new AccountMangementService();
        this.userService = new CurrentUserService();
        this.subnetworkId = this.isChannel ? this.userService.marketplaceUser.subnetworkId : localStorage.getItem('subnetworkId');
        onMounted(() => {
            this.getPartners();
        });
    },
    methods: {
        async getPartners() {
            try {
                const response = await this.accountMangementService.getPartners(this.subnetworkId);
                this.partners = response.data.sort((a, b) => a.name.localeCompare(b.name));
                this.originalPartnerStates = this.partners.reduce((acc, partner) => {
                    acc[partner.id] = partner.isPartOfThisChannel;
                    return acc;
                }, {});
            } catch (error) {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Error fetching partners', 
                    detail: error.message, 
                    life: 3000 
                });
            }
        },

        togglePartner(partner) {
            partner.hasChanged = partner.isPartOfThisChannel !== this.originalPartnerStates[partner.id];
            this.show = this.partners.some(p => p.hasChanged);
        },

        async saveChanges() {
            try {
                const changedPartners = this.partners.filter(partner => partner.hasChanged);
                const partnersToAdd = changedPartners.filter(partner => partner.isPartOfThisChannel)
                const partnersToRemove = changedPartners.filter(partner => !partner.isPartOfThisChannel)

                
                console.log({
                    changedPartners,
                    partnersToAdd,
                    partnersToRemove
                })

                await this.accountMangementService.updatePartnerStatus({
                    subnetworkId: this.subnetworkId,
                    partners: this.partners
                });

                this.$toast.add({
                    severity: 'success',
                    summary: 'Changes saved successfully',
                    life: 3000
                });
                this.show = false;
                await this.getPartners(); // Refresh the list
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error saving changes',
                    detail: error.message,
                    life: 3000
                });
            }
        },

        cancel() {
            this.getPartners(); // Reset to original state
            this.show = false;
        }
    }
};
</script>

<style scoped lang="scss">
::v-deep(.p-multiselect) {
    margin-left: 1rem;
    max-width: 30rem;
}

.custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
}

.uploadButton {
    display: none;
}


::v-deep(.p-accordion-header) {
    font-size: large;
}

::v-deep(.p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link),
::v-deep(.p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link):hover {
    background-color: rgb(228, 228, 228);
    font-weight: 500;
    margin-top: 1rem;
}

::v-deep(.eden-color) {
    background: #0f5b60;
}

::v-deep(.p-button) {
    background: #00796b !important;
    width: 8rem !important;
    border: 2px solid #00796b !important;
}

::v-deep(.p-button.p-button-outlined) {
    background-color: transparent !important;
    color: #00796b !important;
    border: 1px solid;
    margin-right: 1.25rem;
}

.profile-title {
    font-weight: 700;
    font-family: 'Prompt', sans-serif;
    font-size: 27px;
    margin-left: 1rem;
}

::v-deep(.p-inputtext) {
    margin-left: 1rem;
    max-width: 30rem;
}

.field-title {
    margin-left: 1rem;
    font-size: 1.2rem;
    font-weight: 400;
    max-width: 30rem;
    margin-bottom: 1.5rem;
}

.error-msg {
    margin-left: 1.25rem;
    color: red;
    font-size: 1rem;
    font-weight: 400;
}

.link {
    position: relative;
    left: 1.5rem;
    top: 0.5rem;
    cursor: pointer;
}

.link a {
    color: blue;
}

.attach-file {
    color: #126a70;
    margin-left: 3rem;
}

/* Table styles */
.channels-table {
    width: 100%;
    border-collapse: collapse;
    margin-left: 10px;
    margin-top: 10px;
}

.channels-table th,
.channels-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

/* Column styles */
.switch-column {
    width: 10%;
}

.partner-name-column {
    width: 40%;
    font-size: 14px;
}

.template-column {
    width: 20%;
}

.channel-link-column {
    width: 40%;
}

/* Dropdown styles */
/* Ensure the dropdown fills the cell */
.template-dropdown {
    width: 100%;
    padding: 5px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    box-sizing: border-box;
}

/* Style when dropdown is focused (active state) */
.template-dropdown:focus {
    outline: none;
    border-color: #007bff;
    /* Add blue border on focus */
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    /* Subtle blue glow effect */
    background-color: white;
    /* Keep background white on focus */
    color: black;
    /* Ensure text color is black */
}

/* Change the caret (dropdown arrow) color if needed */
.template-dropdown::-ms-expand {
    color: black;
}

/* Optional - Style hover and active states for better UX */
.template-dropdown:hover {
    border-color: #007bff;
    /* Blue border on hover */
}

.template-dropdown:active {
    border-color: #007bff;
}

.channels-table th {
    font-weight: 400;
}

.template-dropdown option {
    border-radius: 0px;
    /* Remove any border-radius on the expanded options */
    background-color: white;
    color: black;
}

.ml-1rem {
    margin-left: 1rem;
}

.mb-1rem {
    margin-bottom: 2rem;
}

/* Customize the dropdown open list */
.template-dropdown:focus option {
    border-radius: 0px;
    /* Ensure no rounded corners for the dropdown list */
    background-color: white;
    color: black;
}

.logo-container {
    position: relative;
}


.channel-logo {
    margin-bottom: 1rem;
    margin-left: 1rem;
    height: 60px;
    object-fit: cover;
}

.cross {
    cursor: pointer !important;
    margin-left: 0.5rem;
    position: absolute;
}


</style>
